const SuccessMessageBox = (props: any) => {

  let successMessage = props.successMessage;
  return (
    <>
      {(successMessage) &&
        <div className="SuccessMessage text-center mt-3">
          {successMessage}
        </div>
      }
    </>
  )
}

export default SuccessMessageBox